import type { UseCase } from '@/core/shared'
import type { AuthRepository } from '../domain'

export const doPasswordResetRequest: UseCase<AuthRepository, 'passwordResetRequest'> = repository => {
  return async (passwordResetRequest) => {
    await repository.passwordResetRequest(passwordResetRequest)
  }
}
